<template lang="html">
  <div>
    <div class="logo-app">
      <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
         viewBox="0 0 600 800" style="enable-background:new 0 0 600 800" xml:space="preserve">
        <path class="st0" ref="pl" d="M300.41,134.82c19.45,0,37.98,4,54.79,11.2c17.35,7.43,32.88,18.26,45.78,31.63
          c10.35,10.74,19.02,23.16,25.54,36.79c5.39,11.23,9.33,23.27,11.59,35.94l41.07-1.62c-3.69-25.82-12.87-49.92-26.31-71.04
          c-9.72-15.31-21.69-29.06-35.43-40.79c-14.43-12.33-30.84-22.42-48.67-29.74c-21.09-8.67-44.16-13.46-68.34-13.46
          c-29.17,0-56.69,6.92-81.01,19.16c-21.6,10.89-40.71,25.97-56.24,44.22c-13.75,16.13-24.72,34.75-32.14,55.08
          c-7.11,19.42-11,40.42-11,62.33c0,14.74,1.76,29.08,5.07,42.8c4.65,19.19,12.36,37.16,22.59,53.4
          c6.89,10.94,14.94,21.09,23.95,30.27c10.43,10.63,22.17,19.96,34.98,27.72c14.88,9.07,31.21,16.04,48.56,20.49
          c14.46,3.71,29.59,5.67,45.24,5.67c21.97,0,43-3.91,62.48-11.08c17.43-6.41,33.62-15.42,48.05-26.56
          c13.32-10.32,25.14-22.42,35.15-36c10.54-14.31,19.02-30.25,24.97-47.37c4.37-12.5,7.4-25.63,8.93-39.23l-41.47-0.79
          c-2.86,20.95-10.37,40.37-21.46,57.23c-7.26,11-16.02,20.92-26.02,29.42c-11.28,9.64-24.15,17.49-38.13,23.16
          c-16.21,6.55-33.96,10.18-52.53,10.18c-25.26,0-48.93-6.75-69.36-18.51c-15.59-8.96-29.28-20.86-40.31-34.92
          c-8.82-11.28-15.96-23.92-21-37.56c-5.58-15.08-8.62-31.35-8.62-48.33c0-19.67,4.03-38.38,11.34-55.36
          c6.72-15.59,16.16-29.71,27.78-41.75c13.01-13.49,28.69-24.35,46.2-31.75C263.05,138.7,281.28,134.82,300.41,134.82L300.41,134.82z"
          />
        <path class="st0" ref="sl" d="M62.87,768.36h32.66h20.41h27.04v-33.22v-31.21v-33.59v-32.4v-41.3c12.44,9.55,25.51,18.03,39.15,25.37
          c21.51,11.57,44.39,20.21,68.23,25.46c17.66,3.91,35.89,5.95,54.48,5.95c20.55,0,40.65-2.52,60.07-7.29
          c17.18-4.2,33.87-10.15,49.86-17.72c18.68-8.79,36.45-19.76,53.15-32.57v28.89v30.02v38.38v37.22v36.99h26.02h29.99h24.09v-43
          v-55.19v-48.02v-47.99v-65.99v-52.24H546c-2.83,3.63-5.24,7.26-8.05,10.49l0,0c-9.86,12.61-20.81,24.32-32.66,35.04
          c-17.01,15.36-35.83,28.69-55.93,39.8c-14.83,8.16-30.3,15.14-46.23,20.83c-14.68,5.22-29.76,9.35-44.99,12.33
          c-18.82,3.66-37.93,5.56-56.98,5.56c-23.27,0-45.98-2.64-67.78-7.63c-20.72-4.76-40.65-11.62-59.5-20.38
          c-11.76-5.47-23.13-11.65-34.02-18.51c-11.96-7.54-23.33-15.85-34.07-24.92c-12.08-10.2-23.36-21.32-33.7-33.25l0,0
          c-3.23-3.63-6.46-7.26-9.27-11.25v60.92v50.4v54v50.4v45.61v43L62.87,768.36z"/>
        <path class="st0" ref="tl" d="M300.41,58.34c23.19,0,45.52,3.66,66.44,10.4c15.53,4.99,30.3,11.71,44.08,19.93
          c14.29,8.5,27.5,18.6,39.4,30.05c9.89,9.5,18.85,19.93,26.79,31.15c9.16,12.95,16.92,26.93,23.07,41.75
          c7.31,17.6,12.39,36.37,14.83,55.93l44.67-1.59c-1.81-16.72-5.19-32.97-10.03-48.59c-5.13-16.67-11.91-32.6-20.13-47.62
          c-8.67-15.93-18.99-30.87-30.67-44.56c-12.76-14.94-27.18-28.4-42.97-40.14C439.82,53.1,422.3,42.95,403.68,34.9
          c-19.36-8.36-39.63-13.44-61.03-16.75c-13.61-2.1-27.67-3.46-42.24-4.51c-25.14,0-49.44,3.54-72.45,10.18
          c-17.01,4.9-33.31,11.51-48.7,19.59c-24.6,12.93-46.89,29.65-66.05,49.38c-13.12,13.52-24.8,28.46-34.78,44.56
          c-13.1,21.15-23.24,44.28-29.88,68.88c-5.9,21.77-9.04,44.67-9.04,68.31c0,23.61,3.15,46.49,9.01,68.26
          c5.75,21.26,14.09,41.44,24.72,60.18c10.15,17.89,22.34,34.5,36.26,49.44c12.56,13.46,26.5,25.6,41.64,36.14
          c19.36,13.55,40.65,24.52,63.38,32.43c26.9,9.38,55.79,14.46,85.89,14.46c18.71,0,36.96-1.96,54.54-5.7
          c23.44-4.96,45.72-13.1,66.36-23.9c20.64-10.77,39.63-24.24,56.55-39.91c16.78-15.56,31.52-33.34,43.74-52.78
          c11.79-18.77,21.23-39.12,27.98-60.69c5.58-17.83,9.3-36.51,10.91-55.76l-44.67-1.22c-1.93,19.45-6.43,38.15-13.15,55.79
          c-5.24,13.72-11.82,26.76-19.62,38.98c-10.32,16.24-22.73,31.01-36.88,43.94c-15.08,13.78-32.12,25.46-50.66,34.55
          c-13.97,6.86-28.8,12.27-44.28,15.99c-16.3,3.94-33.31,6.01-50.83,6.01c-23.56,0-46.23-3.74-67.44-10.69
          c-17.77-5.81-34.5-13.83-49.89-23.78c-13.32-8.62-25.65-18.68-36.77-29.93c-12.36-12.56-23.22-26.65-32.23-41.92
          c-9.52-16.16-17.04-33.65-22.11-52.16c-5.07-18.37-7.77-37.7-7.77-57.71c0-20.66,2.89-40.62,8.28-59.53
          c5.02-17.6,12.19-34.3,21.26-49.75c8.14-13.89,17.74-26.76,28.66-38.44c12.59-13.46,26.87-25.29,42.49-35.18
          c16.81-10.6,35.18-18.96,54.71-24.66C258.88,61.34,279.29,58.34,300.41,58.34L300.41,58.34z"/>
      </svg>
    </div>
  </div>
</template>

<script>

import { TweenMax, TimelineMax } from 'gsap'
import SVGDrawPlugin from '../svgDraw'

export default {
  mounted() {
    const { pl, sl, tl } = this.$refs
    TweenMax.to(pl, 0, {
      drawSVG: "0%",
      delay: 0
    })
    TweenMax.to(sl, 0, {
      drawSVG: "0%",
      delay: 0
    })
    TweenMax.to(tl, 0, {
      drawSVG: "0%",
      delay: 0
    })
    TweenMax.to(pl, 3, {
      drawSVG: true,
      delay: 1
    })
    TweenMax.to(tl, 3, {
      drawSVG: true,
      delay: 2
    })
    TweenMax.to(sl, 3, {
      drawSVG: true,
      delay: 3
    })
    TweenMax.to(pl, 1, {
      fill: '#fff',
      delay: 4
    })
    TweenMax.to(tl, 1, {
      fill: '#fff',
      delay: 5
    })
    TweenMax.to(sl, 1, {
      fill: '#fff',
      delay: 6
    })
  }
}
</script>

<style lang="sass" scoped>
  .as
    width: 100%
    & svg
      width: inherit
    & .st0
      fill: none
      stroke: #fff
      stroke-miterlimit: 10
    & .st1
      fill: none
      stroke: #fff
      stroke-linecap: square
      stroke-miterlimit: 10
    & .st2
      fill: none
      stroke: #fff
      stroke-linecap: round
      stroke-linejoin: round
      stroke-miterlimit: 10

  .logo-app
    display: flex
    align-items: center
    justify-content: center
    & .st0
      fill: transparent
      stroke: #fff
      stroke-width: 13px
      fill-rule: evenodd
      clip-rule: evenodd
    & svg
      width: 75px

</style>



// WEBPACK FOOTER //
// resources/js/components/BaseLogo.vue